import { type TSearchConfigAPIResponse } from '@atlassian/search-client/fetch-search-config';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { isNounsAvailable } from './is-nouns-available';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { isRovoEnabled } from './is-rovo-enabled';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { getJiraIssueIndexedForTenant } from './get-jira-issue-indexed-for-tenant';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { getProductEdition } from './get-product-edition';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { getProductDataRegions } from './get-product-data-regions';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { getRovoFeatures } from './get-rovo-features';

const EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;

/**
 * Extracts the cloudId from the first resource in the 1P config response.
 */
export const getFirstCloudId = (firstPartyResponse: TSearchConfigAPIResponse): string => {
	const match = firstPartyResponse.resources[0]?.id.match(EXTRACT_CLOUD_ID);
	const extractedCloudId = match ? match[1] : '';

	return extractedCloudId;
};
